import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center mb-2" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = {
  key: 1,
  class: "w-9"
}
const _hoisted_4 = { class: "text-primary mr-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_Note = _resolveComponent("Note")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.skill.icon)
          ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
              key: 0,
              icon: _ctx.skill.icon,
              size: "2x",
              class: "mr-4 w-5 h-5 text-secondary"
            }, null, 8, ["icon"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_3)),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.skill.name), 1)
      ]),
      _createVNode(_component_Note, { class: "text-right" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.skill.experience), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_ProgressBar, {
      progress: _ctx.skill.progress
    }, null, 8, ["progress"])
  ]))
}